module.exports = __webpack_public_path__ + "img/Unilever.b1dc68b1.png";